import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { BeneficiaryResources } from 'services/resources/users/beneficiary';

import { Page } from './components/Page';

export const BeneficiaryPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('beneficiaries');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={BeneficiaryResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
